import Service from '@ember/service';
import { service } from '@ember/service';
import ValidationData from '../data/validationdata';
import { LABEL_CATEGORIES, INVALID_CATEGORIES_EXIST } from '../utils/validation';

export default class ValidationService extends Service {
    @service selectionData;
    @service logging;
    @service intl;

    data = ValidationData;

    run() {
        this._prepAdcMetadata();
        this._validatePartItemOptions('ADC');

        this._validatePartItemOptions('Driver');
    }

    _prepAdcMetadata() {
        let recommendedDriversMetadata = this.data.adcRequirements.recommendedDrivers;
        recommendedDriversMetadata.driverOptions = this.selectionData.drivers.map((driver) => driver.part);
    }

    _validatePartItemOptions(partItemType) {
        let allValidations = [];
        this.get(`selectionData.${partItemType.toLowerCase()}s`).forEach((option) =>
            allValidations.push(
                this._validatePartItem(option, this.get(`data.${partItemType.toLowerCase()}Requirements`)),
            ),
        );

        let allInvalidValidations = allValidations.filter((validation) => INVALID_CATEGORIES_EXIST(validation));

        this.logging.logGroup(
            `${partItemType} Missing Data:`,
            allInvalidValidations.length,
            { allInvalidValidations: allInvalidValidations, self: this },
            this.logPartItem,
        );
    }

    _validatePartItem(partItem, requirementsMetadata) {
        let result = {},
            allFailedValidations = [];

        Object.keys(requirementsMetadata).forEach((property) => {
            let propertyValidations = this._validateProperty(property, requirementsMetadata[property], partItem);

            // find all of the invalid validations for this requirement
            let failedValidations = propertyValidations.filter((v) => !v.valid);

            if (Array.isArray(failedValidations) && failedValidations.length) {
                /**
                 * Determine the category results for each partItem property
                 * Add the failed property to the invalid properties
                 */
                failedValidations.forEach((v) => {
                    if (!(v.category in result)) result[v.category] = {};
                    result[v.category][property] = v;
                    allFailedValidations.push(v);
                });
            }
        });

        /**
         * Determine results for each partItem - These decisions shouldn't have to be made for each property
         * Mark the partItem as hidden if an applicable validation has failed
         */
        if (allFailedValidations.filter((v) => v.hidePartItem).length) {
            partItem.selectable = false;
        }

        if (allFailedValidations.length) {
            partItem.invalidData = true;
            result.part = partItem.part;
        }

        return result;
    }

    _validateProperty(property, metadata, partItem) {
        let validations = [];
        metadata.validations.forEach((v) => {
            validations.push(v(property, metadata, partItem));
        });

        return validations;
    }

    logMissingData(invalidCategories) {
        if (Object.keys(invalidCategories).length) {
            this.logging.logGroup(
                invalidCategories.part,
                true,
                { invalidCategories: invalidCategories, self: this },
                this.logPart,
            );
        }
    }

    logPartItem(loggingArgs) {
        let allInvalidValidations = loggingArgs['allInvalidValidations'],
            _self = loggingArgs['self'];
        allInvalidValidations.forEach((validation) => _self.logMissingData(validation));
    }

    logCategory(loggingArgs) {
        let _self = loggingArgs['self'],
            category = loggingArgs['category'],
            invalidCategories = loggingArgs['invalidCategories'],
            categoryIsInvalid = category in invalidCategories,
            intl = _self.intl;
        if (categoryIsInvalid) {
            Object.keys(invalidCategories[category]).forEach((property) => {
                let propertyValidation = invalidCategories[category][property];
                window.console.log(
                    `${property}:\t${intl.t(propertyValidation.translation, propertyValidation.transArgs)}`,
                );
            });
        }
    }

    logPart(loggingArgs) {
        let _self = loggingArgs['self'],
            invalidCategories = loggingArgs['invalidCategories'],
            intl = _self.intl;

        LABEL_CATEGORIES.forEach((category) => {
            let categoryIsInvalid = category in invalidCategories;
            _self.logging.logGroup(
                `${intl.t(`validation.${category}.category`)}`,
                categoryIsInvalid,
                { category: category, invalidCategories: invalidCategories, self: _self },
                _self.logCategory,
            );
        });
    }
}
